import Toast from './toast.vue';
import {createApp} from "vue";
import Notifications from '@kyvg/vue3-notification';

export default {
  install(Vue) {
    let toastInstance = null;
    let app = null
    let el = null
    window.toast = function () {
    };
    let $notify = null

    const methods = {
      open: message => {
        if (toastInstance) {
          $notify(message);
          toastInstance.message = message;
          return;
        }
        el = document.createElement('div')
        app = createApp(Toast);
        const legoToast = Vue.component('lego-toast');
        const legoIcon = Vue.component('lego-icon');
        app.component('lego-toast', legoToast)
        app.component('lego-icon', legoIcon)
        app.use(Notifications);
        
        $notify = app.config.globalProperties.$notify;
        toastInstance = app.mount(el)
        if (message) {
          toastInstance.message = message
        }
        document.body.appendChild(toastInstance.$el);
        $notify(message);
      },
    };

    Vue.config.globalProperties.$toast = methods;
  },
};
